import React, { Component } from 'react';
import ReactDOM from "react-dom";
import Loader from "./Loader";
import { ToastContainer, toast } from 'react-toastify';
import Axios from "axios";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import EnderecoEnprendimentoPartialForm from "./TicketsSupport/EnderecoEnprendimentoPartialForm";
import cep from "cep-promise";
import IntlCurrencyInput from "react-intl-currency-input";
import EstoqueValoresForm from "./TicketsSupport/EstoqueValoresForm";
import EstoqueValoresTable from "./TicketsSupport/EstoqueValoresTable";
import FichaTecnicaEmpreendimento from "./TicketsSupport/FichaTecnicaEmpreendimento";
import { chamadosSelectStyles as selectStyles, chamadosSelectComponents as reactSelectIcons } from "../util/chamadosSelectStyles";

const ASSUNTO_ORDEM_FIXA = ['Erro no sistema', 'Outros'];

const sortAssuntoOutrosLast = (a, b) => {
    const posA = ASSUNTO_ORDEM_FIXA.indexOf(a);
    const posB = ASSUNTO_ORDEM_FIXA.indexOf(b);
    if (posA !== -1 && posB !== -1) return posA - posB;
    if (posA !== -1) return 1;
    if (posB !== -1) return -1;
    return a.localeCompare(b, 'pt-BR');
};

const FIELD_PLACEHOLDER_FONT = {
    fontFamily: "'Archivo', sans-serif",
    fontStyle: 'italic',
    fontWeight: 400,
    fontSize: '20px',
    color: '#B3B3B3',
};

const FIELD_VALUE_FONT = {
    fontFamily: "'Archivo Expanded', sans-serif",
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '19px',
    color: '#5B595B',
};

const BTN_CHAMADO = {
    fontFamily: "'Archivo Expanded', sans-serif",
    fontWeight: 600,
    fontSize: '25px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    padding: '8px 30px',
    borderRadius: 0,
    border: 'none',
    cursor: 'pointer',
};

export default class FormChamado extends Component {

    constructor(props) {
        super();

        this.state = {
            nome: '',
            building_id: '',
            assunto: '',
            cidade: '',
            mensagem: '',
            anexos: [],
            errors: [],
            loading: false,
            success: false,
            assuntos: ['Inclusão de empreendimento', 'Informações faltantes ou incorretas', 'Erro no sistema', 'Outros'],
            observacoes: {
                "Informações faltantes ou incorretas": ['Localização', 'Estoque', 'Preço', 'Tipologia', 'Ficha técnica'],
                "Outros": ['Envio de material', 'Dúvida', 'Sugestão']
            },
            observacao: '',
            bairro: '',
            cep: '',
            endereco: '',
            numero: '',
            complemento: '',
            longitude: '',
            latitude: '',
            cidade_empreendimento: '',
            estado_empreendimento: '',
            tipologias: [],
        }
    }

    searchEmpreendimentos = async (inputQuery) => {
        if (inputQuery.length > 1) {
            try {

                let params = {
                    term: inputQuery
                };

                if (this.state.cidade !== '') {

                    let parts = this.state.cidade.value.split('-');

                    params.cidade = parts[0];
                    params.estado = parts[1];
                }

                let endpoint = route('search-buildings', params);

                let empreendimentos = await axios.get(endpoint);

                return empreendimentos.data;
            } catch (error) {
                console.log(error);
            }
        }
    }

    searchCidade = async (inputQuery) => {
        if (inputQuery.length >= 2) {
            const response = await Axios.get('/cidades/json-options-with-state-on-values/' + inputQuery);
            return response.data;

        }
    }

    updateTipologias = async (tipologias) => {
        await this.setState({
            ...this.state,
            tipologias: tipologias
        }
        );
    }

    submitForm = async (e) => {
        e.preventDefault();

        if (this.state.loading) {
            return;
        }

        if (this.state.mensagem.trim() === '') {
            this.setState({ errors: { mensagem: ['O campo mensagem é obrigatório.'] } });
            return;
        }

        if (this.state.anexos.some((anexo) => anexo.status === 'uploading')) {
            toast.info('Aguarde o envio do(s) anexo(s) terminar.');
            return;
        }

        try {
            await this.setLoading(true);
            await this.setState({
                ...this.state, errors: [],
            });

            if (this.state.observacao === 'Localização' && (this.state.latitude === '' || this.state.longitude === '')) {
                await this.getCoordinatesFromAddress();
            }

            const data = new FormData();

            Object.keys(this.state).forEach(key => {
                if (key !== 'errors' && key !== 'loading' && key !== 'assuntos' && key !== 'anexos') {
                    if (this.state[key] !== null && this.state[key] !== undefined && this.state[key] !== '') {
                        let value = this.state[key];

                        if (key === 'tipologias') {
                            value = JSON.stringify(this.state[key]);
                        }

                        data.append(key, value);

                    }
                }
            });

            this.state.anexos
                .filter((anexo) => anexo.status === 'done' && anexo.token)
                .forEach((anexo) => {
                    data.append('anexos_tokens[]', anexo.token);
                });

            if (this.state.cidade !== '') {
                let parts = this.state.cidade.value.split('-');
                data.append('cidade', parts[0].trim());
                data.append('estado', parts[1].trim());
            }

            if (this.state.building_id !== '') {
                data.delete('nome');
                data.append('empreendimento', this.state.building_id);
            }

            this.setState({ loading: true });

            let response = await axios.post(route('chamado.store'), data);

            if (response.status === 201) {

                if (response.data.anexo_upload_failed) {
                    toast.warn(`Chamado ${response.data.id} criado, mas houve uma falha ao anexar o(s) arquivo(s). Você pode reenviá-los depois pelo chamado.`);
                } else {
                    toast.success(`Chamado ${response.data.id} Criado com sucesso!`);
                }

                await this.setState({ success: true });

                setTimeout(() => {
                    window.location.href = route('chamados.index');
                }, 2000);
            }

        } catch (e) {

            if (e.response && e.response.status === 422) {
                this.setState({ errors: e.response.data.errors });
            } else {
                toast.error('Não foi possível enviar o chamado. Tente novamente em instantes.');
            }

            console.log(e);
        } finally {
            this.setLoading(false);
        }


    }

    setLoading = async (loading) => {

        await this.setState({
            loading: loading
        });
    }


    componentDidMount = async () => {

        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('assunto') && urlParams.get('assunto') === 'sugerir_inclusao') {
            await this.setState({
                ...this.state,
                assunto: 'Inclusão de empreendimento'
            });
        }

        if (urlParams.has('empreendimento')) {
            try {
                await this.setLoading(true);

                let response = await axios.get(route('building.show', urlParams.get('empreendimento')));

                if (response.status === 200) {
                    const latitude = parseFloat(response.data.building.latitude);
                    const longitude = parseFloat(response.data.building.longitude);

                    await this.setState({
                        ...this.state,
                        nome: response.data.building.name,
                        building_id: response.data.building.id,
                        assunto: 'Informações faltantes ou incorretas',
                        cidade: {
                            label: response.data.building.city?.city + ' - ' + response.data.building.city?.state,
                            value: response.data.building.city?.city + '-' + response.data.building.city?.state
                        },
                        empreendimento: {
                            value: response.data.building.id,
                            label: response.data.building.name + ' - ' + response.data.building.city?.city + ' - ' + response.data.building.city?.state
                        },
                        bairro: response.data.building.neighborhood,
                        cep: response.data.building.zip_code,
                        endereco: response.data.building.address,
                        numero: response.data.building.number,
                        complemento: response.data.building.complement,
                        longitude: !isNaN(longitude) ? longitude : '',
                        latitude: !isNaN(latitude) ? latitude : '',
                        cidade_empreendimento: response.data.building.city?.city,
                        estado_empreendimento: response.data.building.city?.state,
                        tipologias: response.data.tipologias
                    });

                    if (isNaN(latitude) || isNaN(longitude)) {
                        await this.getCoordinatesFromAddress();
                    } else {
                        this.centerMap();
                    }
                }
            } catch (e) {
                console.log(e);
            } finally {
                await this.setLoading(false);
            }
        }
    }

    onChangefile = async (e) => {
        const novosArquivos = Array.from(e.target.files);
        e.target.value = '';

        novosArquivos.forEach((arquivo) => this.uploadAnexo(arquivo));
    }

    // Envia o anexo assim que ele é selecionado (antes de o chamado existir), para o
    // usuário já saber na hora se algo deu errado (ex.: falha de storage), em vez de só
    // descobrir depois de clicar em Enviar com o chamado já criado.
    uploadAnexo = async (arquivo) => {
        const tempId = `${Date.now()}-${Math.random()}`;
        const inicioEnvio = Date.now();
        // Upload de arquivo pequeno na rede local termina rápido demais pro indicador de
        // "enviando" ser perceptível; garante um tempo mínimo visível pro usuário perceber
        // que algo aconteceu, em vez de parecer que nada foi anexado.
        const DURACAO_MINIMA_MS = 500;

        this.setState((prevState) => ({
            anexos: [...prevState.anexos, {
                tempId,
                name: arquivo.name,
                size: arquivo.size,
                type: arquivo.type,
                status: 'uploading',
            }],
        }));

        try {
            const formData = new FormData();
            formData.append('anexo', arquivo);

            const response = await axios.post(route('chamado.anexo.upload'), formData);

            const tempoDecorrido = Date.now() - inicioEnvio;
            if (tempoDecorrido < DURACAO_MINIMA_MS) {
                await new Promise((resolve) => setTimeout(resolve, DURACAO_MINIMA_MS - tempoDecorrido));
            }

            let removidoAntesDeTerminar = false;

            this.setState((prevState) => {
                if (!prevState.anexos.some((a) => a.tempId === tempId)) {
                    removidoAntesDeTerminar = true;
                    return null;
                }

                return {
                    anexos: prevState.anexos.map((a) => a.tempId === tempId
                        ? { ...a, token: response.data.token, status: 'done' }
                        : a),
                };
            });

            if (removidoAntesDeTerminar) {
                axios.delete(route('chamado.anexo.delete', response.data.token)).catch(() => {});
            }
        } catch (error) {
            console.log(error);
            toast.error(`Não foi possível anexar o arquivo "${arquivo.name}". Tente novamente.`);
            this.setState((prevState) => ({
                anexos: prevState.anexos.filter((a) => a.tempId !== tempId),
            }));
        }
    }

    removeAnexo = (idx) => {
        const anexo = this.state.anexos[idx];

        this.setState({
            ...this.state, anexos: this.state.anexos.filter((_, i) => i !== idx)
        });

        if (anexo && anexo.token) {
            axios.delete(route('chamado.anexo.delete', anexo.token)).catch(() => {});
        }
    }

    getFileThumbnail = (mimeType, filename) => {
        const mimeMap = {
            'image/gif': '/img/thumb_gif.png',
            'image/jpeg': '/img/thumb_jpg.png',
            'image/jpg': '/img/thumb_jpg.png',
            'image/png': '/img/thumb_png.png',
            'application/pdf': '/img/thumb_pdf.png',
            'application/vnd.ms-powerpoint': '/img/thumb_ppt.png',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': '/img/thumb_ppt.png',
            'application/vnd.ms-excel': '/img/thumb_xls.png',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '/img/thumb_xls.png',
        };
        if (mimeType && mimeMap[mimeType]) return mimeMap[mimeType];
        const extMap = { gif: '/img/thumb_gif.png', jpg: '/img/thumb_jpg.png', jpeg: '/img/thumb_jpg.png', png: '/img/thumb_png.png', pdf: '/img/thumb_pdf.png', ppt: '/img/thumb_ppt.png', pptx: '/img/thumb_ppt.png', xls: '/img/thumb_xls.png', xlsx: '/img/thumb_xls.png' };
        const ext = filename?.split('.').pop()?.toLowerCase();
        return (ext && extMap[ext]) ? extMap[ext] : null;
    }

    onChangeNome = async (e) => {
        this.setState({
            ...this.state, nome: e.target.value
        });
    }

    onChangeAssunto = (e) => {
        const assunto = e.target.value;
        const bloqueiaCidadeEmpreendimento = assunto === 'Erro no sistema' || assunto === 'Outros';

        this.setState({
            ...this.state,
            assunto,
            observacao: "",
            ...(bloqueiaCidadeEmpreendimento ? {
                cidade: '',
                empreendimento: '',
                building_id: '',
                nome: '',
            } : {}),
        });
    }

    onChangeObservacao = (e) => {
        this.setState({
            ...this.state, observacao: e.target.value
        });
    }

    onChangeCidade = (e) => {
        this.setState({
            ...this.state, cidade: e.target.value
        });
    }

    onChangeMensagem = (e) => {
        this.setState({
            ...this.state, mensagem: e.target.value
        });
    }

    onChangeLongitude = async (e) => {
        this.setState({
            ...this.state, longitude: e.target.value
        });

        this.centerMap();
    }

    onChangeLatitude = async (e) => {
        await this.setState({
            ...this.state, latitude: e.target.value
        });

        this.centerMap();
    }

    centerMap = () => {
        let location = {
            lat: parseFloat(this.state.latitude),
            lng: parseFloat(this.state.longitude)
        };

        window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.setCenter(location);

        window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.setZoom(18);

        window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.panTo(
            location
        );

    }

    onChangeEndereco = (e) => {
        this.setState({
            ...this.state, endereco: e.target.value
        });
    }

    onChangeBairro = (e) => {
        this.setState({
            ...this.state, bairro: e.target.value
        });
    }

    onChangeComplemento = (e) => {
        this.setState({
            ...this.state, complemento: e.target.value
        });
    }

    onChangeCep = async (e) => {

        let cepInput = e.target.value.replace(/\D/g, '');

        await this.setState({
            ...this.state, cep: cepInput
        });

        try {
            if (cepInput.length >= 8) {
                let cepResponse = await cep(cepInput);
                console.log(cepResponse);

                if (cepResponse) {
                    this.setState({
                        ...this.state,
                        endereco: cepResponse.street,
                        bairro: cepResponse.neighborhood,
                        cidade_empreendimento: cepResponse.city,
                        estado_empreendimento: cepResponse.state

                    });
                }
            }


        } catch (e) {
            console.log(e);
        }


    }

    waitForGeocoder = (resolve, attempts = 0) => {
        if (window.google && window.google.maps && window.google.maps.Geocoder) {
            resolve();
            return;
        }
        if (attempts > 40) {
            resolve();
            return;
        }
        setTimeout(() => this.waitForGeocoder(resolve, attempts + 1), 100);
    }

    loadGoogleMapsScript = () => {
        return new Promise((resolve) => {
            if (window.google && window.google.maps && window.google.maps.Geocoder) {
                resolve();
                return;
            }
            const existing = document.getElementById('form-chamado-gmaps-script');
            if (existing) {
                this.waitForGeocoder(resolve);
                return;
            }
            window._formChamadoInitMap = () => this.waitForGeocoder(resolve);
            const script = document.createElement('script');
            script.id = 'form-chamado-gmaps-script';
            script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBu0-76sJL5A8Ss84aFm9PrpdoB2pktrgI&libraries=places&callback=_formChamadoInitMap`;
            script.async = true;
            document.head.appendChild(script);
        });
    }

    getCoordinatesFromAddress = async (e) => {
        await this.loadGoogleMapsScript();

        const numero = (this.state.numero || '').toUpperCase() === 'S/N' ? null : this.state.numero;

        const address = [this.state.endereco, numero, this.state.bairro, this.state.cidade_empreendimento, this.state.estado_empreendimento, this.state.cep, 'Brasil']
            .filter(Boolean)
            .join(', ');

        const geocoder = new window.google.maps.Geocoder();

        try {
            const results = await new Promise((resolve, reject) => {
                geocoder.geocode({ address }, (results, status) => {
                    if (status === 'OK' && results[0]) {
                        resolve(results);
                    } else {
                        reject(status);
                    }
                });
            });

            const location = results[0].geometry.location;

            await this.setState({
                ...this.state,
                latitude: location.lat(),
                longitude: location.lng()
            });

            this.centerMap();
        } catch (e) {
            console.log(e);
            toast.error('Não foi possível encontrar a geolocalização para este endereço.');
        }
    }


    onChangeCidadeEmpreendimento = (e) => {
        this.setState({
            ...this.state, cidade_empreendimento: e.target.value
        });
    }

    onChangeEstadoEmpreendimento = (e) => {
        this.setState({
            ...this.state, estado_empreendimento: e.target.value
        });
    }

    onChangeNumero = (e) => {
        this.setState({
            ...this.state, numero: e.target.value
        });
    }

    setLocation = async (markerDragEvent) => {
        await this.setState({
            ...this.state,
            latitude: markerDragEvent.latLng.lat(),
            longitude: markerDragEvent.latLng.lng()
        });

        this.centerMap();
    }

    onChangeEmpreendimento = async (e) => {
        this.setState({
            ...this.state,
            empreendimento: e,
            building_id: e.value
        });

        let buildingId = e.value;

        if (buildingId !== '') {

            await this.setLoading(true);

            try {
                let response = await axios.get(route('building.show', buildingId));

                if (response.status === 200) {

                    const latitude = parseFloat(response.data.building.latitude);
                    const longitude = parseFloat(response.data.building.longitude);

                    await this.setState({
                        ...this.state,
                        bairro: (response.data.building.neighborhood) ? response.data.building.neighborhood : null,
                        cidade_empreendimento: (response.data.building?.city.city) ? response.data.building?.city.city : null,
                        estado_empreendimento: (response.data.building?.city.state) ? response.data.building?.city.state : null,
                        endereco: (response.data.building.address) ? response.data.building.address : null,
                        numero: (response.data.building.number) ? response.data.building.number : null,
                        complemento: (response.data.building.complement) ? response.data.building.complement : null,
                        cep: response.data.building.zip_code ?? null,
                        latitude: !isNaN(latitude) ? latitude : '',
                        longitude: !isNaN(longitude) ? longitude : '',
                        tipologias: response.data.tipologias

                    });

                    if (isNaN(latitude) || isNaN(longitude)) {
                        await this.getCoordinatesFromAddress();
                    } else {
                        this.centerMap();
                    }
                }
            } finally {
                await this.setLoading(false);
            }
        }
    }


    render() {
        const bloqueiaCidadeEmpreendimento = this.state.assunto === 'Erro no sistema' || this.state.assunto === 'Outros';

        return (<>
            <style>{'@keyframes geobrainAnexoSpin { to { transform: rotate(360deg); } }'}</style>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ width: "50%", zIndex: 9999999, fontWieght: 'bold' }}
            />

            {this.state.loading && <Loader />}

            {this.state.success ? (
                <div className="alert alert-success" style={{ ...FIELD_VALUE_FONT, fontSize: '20px', textAlign: 'center', padding: '40px' }}>
                    Chamado enviado com sucesso! Redirecionando...
                </div>
            ) : (
            <form method="post" className="form-chamado">
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="assunto">Assunto</label>
                            <Select
                                inputId="assunto"
                                placeholder="Selecione o assunto"
                                value={this.state.assunto ? { value: this.state.assunto, label: this.state.assunto } : null}
                                options={[...this.state.assuntos].sort(sortAssuntoOutrosLast).map(a => ({ value: a, label: a }))}
                                onChange={(opt) => this.onChangeAssunto({ target: { value: opt ? opt.value : '' } })}
                                styles={selectStyles}
                                components={reactSelectIcons}
                            />
                            {this.state.errors['assunto'] &&
                                <div className="invalid-feedback" style={{ display: "block" }}>
                                    {this.state.errors['assunto'][0]}
                                </div>}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="observacao">Observação</label>
                            <Select
                                inputId="observacao"
                                placeholder={(!this.state.assunto || !this.state.observacoes[this.state.assunto]) ? "" : "Selecione a observação"}
                                isDisabled={!this.state.assunto || !this.state.observacoes[this.state.assunto]}
                                value={this.state.observacao ? { value: this.state.observacao, label: this.state.observacao } : null}
                                options={(this.state.assunto && this.state.observacoes[this.state.assunto])
                                    ? [...this.state.observacoes[this.state.assunto]].sort((a, b) => a.localeCompare(b, 'pt-BR')).map(o => ({ value: o, label: o }))
                                    : []}
                                onChange={(opt) => this.onChangeObservacao({ target: { value: opt ? opt.value : '' } })}
                                styles={selectStyles}
                                components={reactSelectIcons}
                            />
                            {this.state.errors['observacao'] &&
                                <div className="invalid-feedback" style={{ display: "block" }}>
                                    {this.state.errors['observacao'][0]}
                                </div>}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="">Cidade</label>
                            <AsyncSelect
                                cacheOptions
                                placeholder={bloqueiaCidadeEmpreendimento ? "" : "Selecione a cidade..."}
                                value={this.state.cidade}
                                loadOptions={this.searchCidade}
                                isDisabled={bloqueiaCidadeEmpreendimento}
                                onChange={async (e) => {
                                    await this.setState({
                                        ...this.state,
                                        cidade: e
                                    });
                                }}
                                styles={selectStyles}
                                components={reactSelectIcons}
                            />
                            {this.state.errors['cidade'] &&
                                <div className="invalid-feedback" style={{ display: "block" }}>
                                    {this.state.errors['cidade']}
                                </div>}
                        </div>
                    </div>
                    <div className="col-md-6">
                        {this.state.assunto === 'Inclusão de empreendimento' ? (
                            <div className="form-group">
                                <label htmlFor="nome">Empreendimento</label>
                                <input type="text"
                                    className={'form-control' + (this.state.errors.nome ? ' is-invalid' : '')}
                                    name="nome"
                                    onChange={this.onChangeNome}
                                    id="nome" placeholder="Nome do Empreendimento"
                                    value={this.state.nome}
                                    style={{ height: '52px', padding: '10px 12px' }} />
                                {this.state.errors['nome'] &&
                                    <div className="invalid-feedback" style={{ display: "block" }}>
                                        {this.state.errors['nome']}
                                    </div>}
                            </div>
                        ) : (
                            <div className="form-group">
                                <label htmlFor="">Empreendimento</label>
                                <AsyncSelect
                                    cacheOptions
                                    placeholder={bloqueiaCidadeEmpreendimento ? "" : "Selecione o empreendimento..."}
                                    value={this.state.empreendimento}
                                    defaultOptions
                                    isDisabled={bloqueiaCidadeEmpreendimento}
                                    loadOptions={this.searchEmpreendimentos}
                                    onChange={this.onChangeEmpreendimento}
                                    styles={selectStyles}
                                    components={reactSelectIcons}
                                />
                                {this.state.errors['empreendimento'] &&
                                    <div className="invalid-feedback" style={{ display: "block" }}>
                                        {this.state.errors['empreendimento']}
                                    </div>}
                            </div>
                        )}
                    </div>
                </div>

                {(this.state.observacao === 'Localização' && this.state.building_id !== '') &&
                    <EnderecoEnprendimentoPartialForm
                        onChangeEndereco={this.onChangeEndereco}
                        onChangeBairro={this.onChangeBairro}
                        onChangeCep={this.onChangeCep}
                        onChangeCidadeEmpreendimento={this.onChangeCidadeEmpreendimento}
                        onChangeEstadoEmpreendimento={this.onChangeEstadoEmpreendimento}
                        onChangeNumero={this.onChangeNumero}
                        onChangeLatitude={this.onChangeLatitude}
                        onChangeLongitude={this.onChangeLongitude}
                        setLocation={this.setLocation}
                        getCoordinatesFromAddress={this.getCoordinatesFromAddress}
                        state={this.state}
                    />
                }

                {(this.state.observacao === 'Estoque' || this.state.observacao === 'Preço') &&
                    <EstoqueValoresForm
                        state={this.state}
                        observacao={this.state.observacao}
                        updateTipologias={this.updateTipologias}
                    />
                }

                {this.state.observacao === 'Tipologia' &&
                    this.state.tipologias && this.state.tipologias.length > 0 && (
                    <EstoqueValoresTable
                        tipologias={this.state.tipologias}
                        observacao={this.state.observacao}
                    />
                )}

                {this.state.observacao === 'Ficha técnica' && this.state.building_id !== '' && (
                    <FichaTecnicaEmpreendimento buildingId={this.state.building_id} />
                )}

                <div className="form-group">
                    <label htmlFor="mensagem">Mensagem</label>
                    <textarea className={`form-control ` + (this.state.errors.mensagem ? 'is-invalid' : '')}
                        onChange={this.onChangeMensagem}
                        value={this.state.mensagem}
                        name="mensagem"
                        placeholder="Escreva aqui o detalhamento da sua solicitação.."
                        style={{ height: '150px', borderRadius: 0, resize: 'none', ...FIELD_VALUE_FONT }}
                        id="mensagem"></textarea>
                    {this.state.errors['mensagem'] &&
                        <div className="invalid-feedback" style={{ display: "block" }}>
                            {this.state.errors['mensagem'][0]}
                        </div>}
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-end', gap: '15px' }}>
                    {this.state.anexos && this.state.anexos.length > 0 &&
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                            {this.state.anexos.map((a, idx) => {
                                const thumb = this.getFileThumbnail(a.type, a.name);
                                const enviando = a.status === 'uploading';
                                return (
                                    <span key={a.tempId || idx} title={enviando ? `Enviando ${a.name}...` : a.name} style={{ position: 'relative', display: 'inline-flex', opacity: enviando ? 0.5 : 1 }}>
                                        {thumb
                                            ? <img src={thumb} alt={a.name} title={a.name} style={{ height: '50px', width: 'auto', objectFit: 'contain' }} />
                                            : <i className="fa fa-paperclip" style={{ fontSize: '50px', color: '#4D5830' }} />}
                                        {enviando &&
                                            <span aria-hidden="true" style={{
                                                position: 'absolute', bottom: '-4px', right: '-4px',
                                                width: '16px', height: '16px', boxSizing: 'border-box',
                                                borderRadius: '50%', backgroundColor: '#FFFFFF',
                                                border: '2px solid #4D5830', borderTopColor: 'transparent',
                                                animation: 'geobrainAnexoSpin 0.6s linear infinite',
                                            }} />}
                                        <span
                                            onClick={() => this.removeAnexo(idx)}
                                            title="Remover"
                                            style={{
                                                position: 'absolute', top: '-6px', right: '-6px',
                                                width: '16px', height: '16px', borderRadius: '50%',
                                                backgroundColor: '#CF3C3E', color: '#FFFFFF',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                fontSize: '11px', lineHeight: 1, cursor: 'pointer',
                                            }}
                                        >
                                            &times;
                                        </span>
                                    </span>
                                );
                            })}
                        </div>}
                    <div className="chamados-button-group" style={{ marginTop: 0, marginLeft: 'auto' }}>
                        <label htmlFor="anexos" className="btn btn-anexar" style={{ ...BTN_CHAMADO, backgroundColor: '#B2B2B2', color: '#FFFFFF' }}>
                            Anexar
                        </label>
                        <input type="file" name="anexos[]" onChange={this.onChangefile} id="anexos"
                            multiple="multiple" disabled={this.state.loading} style={{ display: 'none' }} />
                        <button type="button" className="btn btn-enviar" onClick={this.submitForm}
                            disabled={this.state.loading || this.state.anexos.some((a) => a.status === 'uploading')}
                            style={{
                                ...BTN_CHAMADO, backgroundColor: '#4D5A31', color: '#FFFFFF',
                                opacity: (this.state.loading || this.state.anexos.some((a) => a.status === 'uploading')) ? 0.6 : 1,
                                cursor: (this.state.loading || this.state.anexos.some((a) => a.status === 'uploading')) ? 'not-allowed' : 'pointer',
                            }}>
                            Enviar
                        </button>
                    </div>
                </div>
                {this.state.errors['anexos'] &&
                    <div className="invalid-feedback" style={{ display: "block", marginTop: '10px' }}>
                        {this.state.errors['anexos'][0]}
                    </div>}
            </form>
            )}
        </>);
    }
}

if (document.getElementById('js-form-chamado')) {
    ReactDOM.render(<FormChamado />, document.getElementById('js-form-chamado'));
}
